import { defineComponent, onMounted } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import GeotargetingIncentive from '@/presentation/components/entities-and-geotargeting/geotargeting-incentive/geotargeting-incentive.vue';
import TableEntitiesSearchInput from '@/presentation/components/entities-and-geotargeting/table-entities-search/search-input.vue';
import TableEntities from '@/presentation/components/entities-and-geotargeting/table-entities/table-entities.vue';
import EntitiesAndGeotargetingCode from '@/presentation/components/entities-and-geotargeting/entities-and-geotargeting.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		GeotargetingIncentive,
		TableEntitiesSearchInput,
		TableEntities
	},
	setup: () => {
		const code = new EntitiesAndGeotargetingCode();

		onMounted(code.mounted.bind(code));

		return {
			isLoading: code.isLoading
		};
	}
});
